import React, { useCallback, useContext, useState } from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';
import { PaymentContext } from '../../PaymentOrchestrator/PaymentContextProvider';
import useBillingChangeInfo from '../hooks/useBillingChangeInfo';
import useGooglePay from '../hooks/useGooglePay';
import { GooglePayContainer, GooglePaySkeleton } from './index.styles';

const GooglePay = ({ onSuccess, onError, isMethodChange = false, isBillingDateChange = false }) => {
  const [googlePayButtonContainer, setGooglePayButtonContainer] = useState(null);
  const [isGooglePayReady, setIsGooglePayReady] = useState(false);

  const paymentContext = useContext(PaymentContext);
  const billingChangeInfo = useBillingChangeInfo({
    upgradeOffer: paymentContext?.resolvedUpgradeOffer,
    isTrial: paymentContext?.resolvedIsTrial,
  });
  const billingDateChangeProRataPrice = useSelector(state => state.oneTimePayment?.price);

  // Use values conditionally based on isBillingDateChange flag
  const { resolvedUpgradeOffer, resolvedIsTrial } = isBillingDateChange ? {} : paymentContext;
  const { price: offerPrice, proRataPrice, isProRataMovement } = isBillingDateChange ? {} : billingChangeInfo;
  const selectedPlanPrice = isBillingDateChange ? undefined : paymentContext?.selectedPlanOverride?.price;
  const price = selectedPlanPrice ?? offerPrice;

  const googlePayRef = useCallback(node => {
    if (node !== null) {
      setGooglePayButtonContainer(node);
    }
  }, []);

  const billingDetails = {
    isMethodChange,
    upgradeOffer: resolvedUpgradeOffer,
    isTrial: resolvedIsTrial,
    price,
    proRataPrice,
    billingDateChangeProRataPrice: isBillingDateChange ? billingDateChangeProRataPrice : null,
    isProRataMovement,
  };

  useGooglePay(googlePayButtonContainer, billingDetails, onSuccess, onError, setIsGooglePayReady);

  return (
    <React.Fragment>
      {!isGooglePayReady && <GooglePaySkeleton aria-label="Loading Google Pay" />}
      <GooglePayContainer
        ref={googlePayRef}
        className="google-pay-button"
        role="button"
        aria-label="Pay with Google Pay"
        style={{ display: isGooglePayReady ? 'flex' : 'none' }}
      />
    </React.Fragment>
  );
};

GooglePay.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  isMethodChange: PropTypes.bool,
  isBillingDateChange: PropTypes.bool,
};

export default GooglePay;
